import React, { useState, useEffect } from "react";
import "./print.css"; // Include animations and styles here
import Footer from "../Footer";

const Print = () => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [message, setMessage] = useState("Story is being uploaded...");
  
  useEffect(() => {
    const interval = setInterval(() => {
      setMessage((prevMessage) =>
        prevMessage === "Story is being uploaded..."
          ? "Stay Tuned, Coming Soon!!!"
          : "Story is being uploaded..."
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const handlePrint = () => {
    setIsPrinting(true);

    // Stop the animation after 5 seconds
    setTimeout(() => {
      setIsPrinting(false);
    }, 5000);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh", // Full viewport height
      }}
    >
      {/* Main Content */}
      <div style={{ flex: 1, textAlign: "center", marginTop: "50px" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "20px" }}>{message}</h2>
        <div className="printer-container">
          <div className="printer">
            <div className={`paper ${isPrinting ? "printing" : ""}`}>
              <p className="print-text">Hello, I'm printing your document!</p>
            </div>
            <div className="printer-slot"></div>
          </div>
          <button
            className="print-button"
            onClick={handlePrint}
            disabled={isPrinting}
          >
            {isPrinting ? "Printing..." : "Print"}
          </button>
        </div>
      </div>
      <div style={{ marginTop: "auto", paddingBottom: "190px" }}></div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Print;



